<script>
	import { page } from '$app/stores';
	import { onMount } from 'svelte';

	// TODO: Replace the inner onMount function with a simple call to the native authjs signin method
	// once the language is determined via the domain name
	onMount(async () => {
		// custom page that opens inside the popup and sends us back a postMessage
		const callbackUrl = new URL(`/authentication/login-callback`, window.location.origin);

		const gotoPage = new URLSearchParams(window.location.search).get('gotoPage');

		if (gotoPage) {
			callbackUrl.searchParams.set('gotoPage', gotoPage);
		}

		const signInUrl = `/auth/signin/salesforce`;

		const res = await fetch(signInUrl, {
			method: 'post',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'X-Auth-Return-Redirect': '1',
				'x-locale': $page.data.locale,
			},
			body: new URLSearchParams({
				callbackUrl: callbackUrl.toString(),
			}),
		});

		const data = await res.clone().json();

		window.location = data.url;
	});
</script>
